// -----------------------------------------------------------------------------
// ProfileTable.jsx – table avec pills compétences et disponibilité stylées
// -----------------------------------------------------------------------------
import React from "react";
import {
  Avatar,
  Box,
  Chip,
  IconButton,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getMedusaInspiredColor, getInitials } from "../../utils/utils";
import { getImageUrl } from "../../services/apiService";
import "./styles/ProfileTable.css";

export default function ProfileTable({ rows = [], onSelect = () => {} }) {
  const AvatarRenderer = ({ row }) => {
    const [url, setUrl] = React.useState("");
    React.useEffect(() => {
      (async () => {
        if (row.localImagePath && row.localImagePath !== "Non spécifié") {
          setUrl(await getImageUrl(row.localImagePath));
        }
      })();
    }, [row.localImagePath]);
    return (
      <Avatar
        src={url || undefined}
        sx={{
          width: 40,
          height: 40,
          fontSize: 14,
          bgcolor:
            row.localImagePath && row.localImagePath !== "Non spécifié"
              ? "transparent"
              : getMedusaInspiredColor(row.nom),
        }}
      >
        {!url && getInitials(row.nom)}
      </Avatar>
    );
  };

  return (
    <TableContainer component={Paper} className="profile-table-container">
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Nom prénom</TableCell>
            <TableCell>Statut</TableCell>
            <TableCell>Poste</TableCell>
            <TableCell align="center">Compétences</TableCell>
            <TableCell align="center">Expériences</TableCell>
            <TableCell align="center">Tarif</TableCell>
            <TableCell align="center">Ville</TableCell>
            <TableCell align="center" width={80}></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.id}
              className="profile-row"
              onClick={() => onSelect(row)}
            >
              <TableCell>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AvatarRenderer row={row} />
                  <Box>
                    <Typography fontWeight={600}>{row.nom}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      @{row.username || row.nom.toLowerCase()}
                    </Typography>
                  </Box>
                </Box>
              </TableCell>

              <TableCell align="center">
                <Chip
                  label={row.disponibilite ? "Disponible" : "Non disponible"}
                  size="small"
                  className={row.disponibilite ? "pc-availability" : "pc-unavailability"}
                />
              </TableCell>

              <TableCell>{row.poste || "—"}</TableCell>

              <TableCell align="center">
                <Box display="flex" flexWrap="wrap" gap={1} justifyContent="center">
                  {(row.competences || "")
                    .split(",")
                    .slice(0, 5)
                    .map((c, i) => (
                      <Chip
                        key={i}
                        label={c.trim()}
                        size="small"
                        sx={{
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          px: 1.5,
                          height: 28,
                          borderRadius: "16px",
                          bgcolor: i % 2 === 0 ? "#e6f1ff" : "#ece8ff",
                          color: i % 2 === 0 ? "#007bff" : "#6a4cff",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    ))}
                </Box>
              </TableCell>

              <TableCell align="center">
                {row.inter_exp ? `${row.inter_exp} years` : "—"}
              </TableCell>

              <TableCell align="center">
                {row.tarif ? `${row.tarif}€/j` : "—"}
              </TableCell>

              <TableCell align="center">{row.localisation || "—"}</TableCell>

              <TableCell align="center">
                <Tooltip title="Voir le profil">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelect(row);
                    }}
                    className="icon-button-view"
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
